const isProduction = process.env.NODE_ENV === "production";

export const register = () => {
	if (!isProduction || !("serviceWorker" in navigator)) return;

	const publicUrl = new URL(
		process.env.PUBLIC_URL || ".",
		window.location.href,
	);
	if (publicUrl.origin !== window.location.origin) return;

	window.addEventListener("load", () => {
		const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

		navigator.serviceWorker.register(swUrl).catch((error) => {
			console.error("Service worker registration failed:", error);
		});
	});
};

export const unregister = () => {
	if (!("serviceWorker" in navigator)) return;

	navigator.serviceWorker.ready
		.then((registration) => registration.unregister())
		.catch((error) => {
			console.error("Service worker unregistration failed:", error);
		});
};
